<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0; /* no uses el = aquí, usa los : */
  padding: 0;
}
.el-form-item__label {
  font-size: 15px !important;
  color: #000000 !important;
  line-height: 30px !important;
  text-align: left !important;
}
.el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before, .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
  color: #ff0000 !important
}
.el-form-item__error {
  color: #ff0000 !important
}
.el-input__inner {
  color: #000000 !important;
  border: 3px solid #948c8c !important;
}
.el-form-item {
  margin-bottom: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue